import { useMutation } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const useCreatePaypalToken = () => {
  const mutation = useMutation({
    mutationFn: paymentRepo.createPaypalToken,
  });

  return useMutationMemoized(mutation);
};

export type CreatePaypalTokenMutation = ReturnType<typeof useCreatePaypalToken>;
